// Route guards. Authorization is ALWAYS re-checked server-side by Firestore rules;
// these guards are UX (where to send the user), never the security boundary.
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.jsx";

export function Loading() {
  return <div className="loading" role="status" aria-live="polite">Loading…</div>;
}

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

/** Beta wall: signed in but no betaAccess → invite screen. */
export function RequireBeta({ children }) {
  const { betaAccess, loading } = useAuth();
  if (loading) return <Loading />;
  if (!betaAccess) return <Navigate to="/invite" replace />;
  return children;
}
